import type {ReactElement} from 'react';
import {Icon} from '@Components/icon-v2';
import {IconSize} from '@Components/icon-v2/icon.types';
import {Text, TextSize} from '@Components/text';
import type {PaymentOptionCardProps} from '@Components/checkout-flow/components/payment-option-card/payment-option-card.types';
import styles from './payment-option-card.module.scss';

export function PaymentOptionCard({imageUrl, imageAlt, imageClassName = '', title, warning = null, cta}: PaymentOptionCardProps): ReactElement {
  const getWarning = (): ReactElement | null => {
    if (warning === null) {
      return null;
    }
    return (
      <div className={styles.warning} title={warning.tooltip}>
        <Icon icon="icon-info" size={IconSize.SIZE_ICON_16} className="content-danger" ariaHidden />
        <Text val={warning.text} size={TextSize.SM} bold className="content-danger" />
      </div>
    );
  };

  return (
    <div className={styles.card}>
      <div className={styles.imageContainer}>
        <img src={imageUrl} alt={imageAlt} className={`${styles.image} ${imageClassName}`} />
        <Text val={title} size={TextSize.LG} className={`content-body ${styles.caption}`} />
      </div>
      <div>
        {getWarning()}
        {cta}
      </div>
    </div>
  );
}
